/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
export function getDistanceDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    return { pairs: [{ loci: [lociA, lociB] }] };
}
export function getAngleDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    var lociC = s[2].loci;
    return { triples: [{ loci: [lociA, lociB, lociC] }] };
}
export function getDihedralDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    var lociC = s[2].loci;
    var lociD = s[3].loci;
    return { quads: [{ loci: [lociA, lociB, lociC, lociD] }] };
}
export function getLabelDataFromStructureSelections(s) {
    var loci = s[0].loci;
    return { infos: [{ loci: loci }] };
}
export function getOrientationDataFromStructureSelections(s) {
    var loci = s[0].loci;
    return { locis: [loci] };
}
//# sourceMappingURL=helpers.js.map